module.exports = __webpack_public_path__ + "img/Rectangle 217.c2d5498f.png";